//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDatePsa() {

  return (

    <DateController
        category = "prostate_cancer_prevention"  
    /> 

  );
}
